import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 5.464c0-.532.432-.964.964-.964h16.072a.963.963 0 1 1 0 1.929H3.964A.963.963 0 0 1 3 5.464m2.571 6.429c0-.535.432-.964.965-.964h10.928c.535 0 .965.43.965.964s-.43.964-.965.964H6.536a.963.963 0 0 1-.965-.964m8.036 7.393h-3.214a.96.96 0 0 1-.964-.965c0-.534.43-.964.964-.964h3.214c.535 0 .964.43.964.964 0 .535-.43.965-.964.965"
    }, null, -1)
  ]))]))
}
export default { render: render }